<template>
  <div class="laporan" :class="{ 'animate-flicker': loading }">
    <div>
      <h2>{{ $route.params.id < 0 ? "Tambah" : "Ubah" }} Outlet</h2>

      <div class="form-wrapper">
        <form @submit.prevent="save">
          <div class="form-group">
            <label>Nama Bisnis</label>
            <input type="text" v-model="data.nama" />
          </div>
          <div class="form-group" v-show="false">
            <label>Email</label>
            <input
              type="email"
              v-model="data.email"
              :disabled="$route.params.id > 0"
            />
            <small
              v-show="$route.params.id > 0"
              style="color: #777; font=size: 12px"
              >Email tidak dapat diubah</small
            >
          </div>
          <div class="form-group">
            <label>No Telp</label>
            <input type="tel" v-model="data.no_telp" />
          </div>
          <div class="form-group">
            <label>Alamat</label>
            <textarea v-model="data.alamat" rows="4"></textarea>
          </div>
          <div class="form-group">
            <label>Jenis Produk</label>
            <select v-model="data.jenis_produk">
              <option
                v-for="(item, index) in dataJenisProduk"
                :key="index"
                :value="item.nama"
              >
                {{ item.nama }}
              </option>
            </select>
          </div>
          <div class="form-group button">
            <button type="submit" class="btn-fill" :disabled="loadingButton">
              Simpan
            </button>
            <button type="button" class="btn-outline" @click="back()">
              Kembali
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../api/Api";

export default {
  name: "Outlet",
  data() {
    return {
      openFilter: false,
      data: {},
      dataJenisProduk: [],
      loading: false,
      loadingButton: false,
      btnHapus: "hapus",
    };
  },
  methods: {
    loadJenisProduk() {
      api.get("/v4/toko?id=" + this.$toko.id).then((r) => {
        this.dataJenisProduk = r.data_jenis_produk;
      });
    },
    loadData() {
      this.loading = true;
      api
        .get("/v4/toko?id=" + this.$route.params.id)
        .then((r) => {
          this.data = r.data;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$toast("Gagal mengambil data");
        });
    },
    preview(evt) {
      const [file] = evt.target.files;
      if (file) {
        const src = URL.createObjectURL(file);
        document.querySelector(".logo-bisnis > div").style.backgroundImage =
          "url(" + src + ")";

        this.upload(file);
      }
    },
    save() {
      if (
        !this.data.nama ||
        !this.data.no_telp ||
        !this.data.alamat ||
        !this.data.jenis_produk
      ) {
        this.$toast("Lengkapi datanya ya");
        return;
      }
      this.loadingButton = true;

      api
        .post("/v4/toko/save", this.data)
        .then((r) => {
          if (r.valid) {
            this.$router.go(-1);
          } else {
            this.$toast(r.message);
          }
          this.loadingButton = false;
        })
        .catch((e) => {
          this.$toast("Gagal mengupdate data, coba lagi ya");
          this.loadingButton = false;
        });
    },
    back() {
      this.$router.go(-1);
    },
  },
  mounted() {
    this.loadJenisProduk();
    if (this.$route.params.id > 0) {
      this.loadData();
    } else {
      this.data.id_parent = this.$toko.id;
    }
  },
};
</script>

<style scoped lang="scss">
.laporan {
  > div {
    margin: 20px;
  }
  h2 {
    margin: 0;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }
  .form-wrapper {
    margin-top: 30px;
    form {
      width: 450px;
      .form-group.button {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-column-gap: 15px;
      }
      .autocomplete {
        position: relative;
        .autocomplete-option {
          position: absolute;
          background-color: #fff;
          border: 1px solid #ccc;
          box-shadow: 0px 2px 3px #ccc;
          border-radius: 5px;
          width: 100%;
          margin-top: 10px;
          ul {
            list-style-type: none;
            padding: 0;
            margin: 0;
            li {
              padding: 10px;
              font-size: 14px;
              border-bottom: 1px solid #ccc;
              &.active {
                background-color: var(--primary);
                color: #fff;
              }
            }
          }
        }
      }
    }
  }

  .btn-group {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;

    button {
      border: 0;
      padding: 12px;
      background: #fff;
      &.active {
        background: var(--light-blue);
      }
      &:first-child {
        border-radius: 6px 0 0 6px;
        &.active {
          border-right: 1px solid #ccc;
        }
      }
      &:last-child {
        border-radius: 0 6px 6px 0;
        &.active {
          border-left: 1px solid #ccc;
        }
      }
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    margin: 0;
    background-color: rgba(0, 0, 0, 0.5);
    .modal-body {
      background: #fff;
      padding: 15px;
      height: 130px;
      margin-top: 100px;
      border-radius: 10px;
      label {
        font-size: 14px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pengaturan/OutletForm.vue